import type {z} from "zod";

import {CreateSupplierFunctionBody} from "@project/sdk/engineering/zod";

export const createSupplierFunctionFormSchema = CreateSupplierFunctionBody;
export type CreateSupplierFunctionFormPayload = z.output<typeof createSupplierFunctionFormSchema>;

export const draftCreateSupplierFunctionFormSchema = createSupplierFunctionFormSchema.partial();
export type DraftCreateSupplierFunctionFormPayload = z.output<
  typeof draftCreateSupplierFunctionFormSchema
>;
